<template>
  <div>
    <Gallery :mode="'travel'" :voyage_id="id"/>
  </div>
</template>

<script>
import Gallery from "../components/Gallery.vue"
export default {
  name: "TravelPhotos",
  data() {
    return {
      id: Number(this.$route.params.id)
    };
  },
  components: {
    Gallery
  },
  mounted() {
  }
};
</script>

<style scoped>

</style>